import { useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoggedUser } from "../../Redux/Actions/userActions";
import "./changePassword.css";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const loggedUser = useSelector((state) => state.users.loggedUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!password) {
      setError("Vendosni passwordin e ri.");
      return;
    }

    if (!passwordRegex.test(password)) {
      setError(
        "Passwordi duhet të ketë të paktën 8 karaktere, një shkronjë të madhe, një shkronjë të vogël, një numër dhe një simbol.",
      );
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwordet nuk përputhen.");
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.put(
        "https://api.arkiva.gov.al/api/users/change-password",
        {
          password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      dispatch(
        setLoggedUser({
          ...loggedUser,
          mustChangePassword: false,
        }),
      );

      navigate("/manage/dashboard");
    } catch (error) {
      console.error("Error changing password:", error);

      setError(
        error.response?.data?.message ||
          "Ndodhi një gabim gjatë ndryshimit të passwordit.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-page">
      <div className="change-password-overlay"></div>

      <div className="change-password-modal">
        {loading && (
          <div className="change-password-loading">
            <div className="spinner"></div>
          </div>
        )}

        <div className="change-password-icon">
          <i className="fa-solid fa-lock"></i>
        </div>

        <h2>Ndrysho Passwordin</h2>

        <p className="change-password-description">
          Për arsye sigurie, duhet të ndryshoni passwordin e përkohshëm përpara
          se të vazhdoni.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="change-password-group">
            <label htmlFor="password">Passwordi i ri</label>

            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                autoComplete="new-password"
                placeholder="Vendosni passwordin e ri"
              />

              <button
                type="button"
                className="show-password-btn"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <i
                  className={`fa-solid ${
                    showPassword ? "fa-eye-slash" : "fa-eye"
                  }`}
                ></i>
              </button>
            </div>
          </div>

          <div className="change-password-group">
            <label htmlFor="confirmPassword">Konfirmo passwordin e ri</label>

            <div className="password-input-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setError("");
                }}
                autoComplete="new-password"
                placeholder="Përsëritni passwordin e ri"
              />

              <button
                type="button"
                className="show-password-btn"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                <i
                  className={`fa-solid ${
                    showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                  }`}
                ></i>
              </button>
            </div>
          </div>

          <div className="password-rules">
            <p>Passwordi duhet të përmbajë:</p>

            <span>
              <i className="fa-solid fa-check"></i>
              Minimumi 8 karaktere
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Të paktën një shkronjë të madhe
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Të paktën një shkronjë të vogël
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Të paktën një numër
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Të paktën një simbol
            </span>
          </div>

          {error && (
            <div className="change-password-error">
              <i className="fa-solid fa-circle-exclamation"></i>
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            className="change-password-submit"
            disabled={loading}
          >
            {loading ? "Duke ruajtur..." : "Ndrysho Passwordin"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
